import React from 'react';

export default function BlogSectionBlog2() {
    return (
        <React.Fragment>
            <>
                <section className="pt-20 pb-32 overflow-hidden">
  <div className="container mx-auto px-4">
    <div className="md:max-w-lg mb-24">
      <h2 className="mb-4 font-heading font-semibold text-gray-900 text-6xl sm:text-7xl">From our blog</h2>
      <p className="text-lg text-gray-500">Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim.</p>
    </div>
    <div className="flex flex-wrap -m-11">
      <div className="w-full md:w-1/2 p-11"><a className="group" href="#">
          <div className="flex flex-wrap items-center -m-4">
            <div className="w-auto p-4">
              <div className="overflow-hidden rounded-xl"><img className="transform hover:scale-110 transition ease-out duration-500" src="gradia-assets/images/blog/blog-avatar.png" alt /></div>
            </div>
            <div className="flex-1 p-4">
              <p className="mb-4 font-heading font-medium text-xl text-gray-900 group-hover:underline">You will never believe these bizarre truth of travel. </p>
              <h2 className="font-heading font-medium text-xs uppercase text-gray-500 tracking-px">Technology  .  4 min read</h2>
            </div>
          </div></a></div>
      <div className="w-full md:w-1/2 p-11"><a className="group" href="#">
          <div className="flex flex-wrap items-center -m-4">
            <div className="w-auto p-4">
              <div className="overflow-hidden rounded-xl"><img className="transform hover:scale-110 transition ease-out duration-500" src="gradia-assets/images/blog/blog-avatar2.png" alt /></div>
            </div>
            <div className="flex-1 p-4">
              <p className="mb-4 font-heading font-medium text-xl text-gray-900 group-hover:underline">You will never believe these bizarre truth of travel. </p>
              <h2 className="font-heading font-medium text-xs uppercase text-gray-500 tracking-px">Technology  .  4 min read</h2>
            </div>
          </div></a></div>
    </div>
  </div>
</section>


            </>
        </React.Fragment>
    );
}

